import React from "react";
import styled from "styled-components";
import { DropdownOption } from "hooks/useDropdownValues";
import { InputLabel } from "./Input";
import styles from "styles/styles";

const ButtonFilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    min-height: 43px;
    padding: 0;
`;

export const StyledButton = styled.button<{ isActive: boolean }>`
    padding: 8px 12px;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid rgb(109, 131, 143);
    background-color: white;
    color: rgb(62, 86, 96);
    cursor: pointer;
    border-radius: 0;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
        border-color 0.2s ease-in-out;
    height: 43px;

    &:hover {
        outline: 1px solid ${styles.colors.focusBorderColor};
    }

    ${(props) =>
        props.isActive &&
        `
        background-color: ${styles.colors.red};
        color: ${styles.colors.white};
        border-color: ${styles.colors.red};
    `}
`;

interface ButtonFilterProps {
    label: string;
    options: DropdownOption[];
    selectedValue: string;
    onValueChange: (value: string) => void;
}

const ButtonFilter: React.FC<ButtonFilterProps> = ({
    label,
    options,
    selectedValue,
    onValueChange,
}) => {
    const handleButtonClick = (value: string) => {
        onValueChange(selectedValue === value ? "" : value);
    };

    return (
        <div>
            <InputLabel>{label}</InputLabel>
            <ButtonFilterContainer>
                {options.map((option) => (
                    <StyledButton
                        key={option.value}
                        onClick={() => handleButtonClick(option.value)}
                        isActive={selectedValue === option.value}
                    >
                        {option.label}
                    </StyledButton>
                ))}
            </ButtonFilterContainer>
        </div>
    );
};

export default ButtonFilter;
